import React from 'react';
import ModeStatCard from '../ModeStatCard';
import { cardSummaryStyle } from './styles';

const MODE_LABELS = [
  { key: 'HP', label: 'Hardpoint' },
  { key: 'SND', label: 'Search & Destroy' },
  { key: 'CTL', label: 'Control' },
];

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 13,
  color: '#e4e4e7',
};

const cellStyle = {
  padding: '8px 10px',
  borderTop: '1px solid rgba(63,63,70,0.8)',
  textAlign: 'left',
};

const FilteredStatsTab = ({
  selectedSeason,
  seasonDisplayLabel,
  filteredSummary,
  filteredModeCards,
  filteredGameHighs,
  winLossSplit,
  mapPerformance,
  operatorAnalytics,
}) => {
  return (
    <section>
      <p className="ppm-message" style={{ marginBottom: 10 }}>
        Season: {seasonDisplayLabel || selectedSeason || 'Current Season'}
      </p>
      <div className="ppm-summary-grid">
        <div style={cardSummaryStyle}>
          <div className="ppm-stat-label">Total Games</div>
          <div className="ppm-stat-value">{filteredSummary.totalGames}</div>
        </div>
        <div style={cardSummaryStyle}>
          <div className="ppm-stat-label">Overall K/D</div>
          <div className="ppm-stat-value">{filteredSummary.overallKD ?? '--'}</div>
        </div>
      </div>

      {!filteredModeCards.length ? (
        <p className="ppm-message">No statistics found for this player with the current filters.</p>
      ) : (
        <>
          <div className="ppm-modes-grid">
            {filteredModeCards.map((modeCard) => (
              <ModeStatCard key={modeCard.key} title={modeCard.label} stats={modeCard.stats} />
            ))}
          </div>

          <h4 className="ppm-section-title">Performance Extremes</h4>
          {MODE_LABELS.map((mode) => {
            const highs = filteredGameHighs[mode.key];
            return (
              <div key={`highs-${mode.key}`}>
                <div className="ppm-high-mode">{mode.label}</div>
                <div className="ppm-highs-grid">
                  <div className="ppm-high-card"><div className="ppm-high-label">Highest K/D</div><div className="ppm-high-value">{highs.highestKD}</div></div>
                  <div className="ppm-high-card"><div className="ppm-high-label">Highest Kills</div><div className="ppm-high-value">{highs.highestKills}</div></div>
                  <div className="ppm-high-card"><div className="ppm-high-label">Highest Impact</div><div className="ppm-high-value">{highs.highestImpact}</div></div>
                  <div className="ppm-high-card"><div className="ppm-high-label">Highest Assists</div><div className="ppm-high-value">{highs.highestAssists}</div></div>
                  <div className="ppm-high-card"><div className="ppm-high-label">Highest Score</div><div className="ppm-high-value">{highs.highestScore}</div></div>
                </div>
              </div>
            );
          })}

          <h4 className="ppm-section-title">Win/Loss Split</h4>
          <div style={{ border: '1px solid rgba(63,63,70,0.9)', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
            <table style={tableStyle}>
              <thead style={{ background: 'rgba(24,24,27,0.85)' }}>
                <tr>
                  <th style={cellStyle}>Metric</th>
                  <th style={cellStyle}>Wins ({winLossSplit?.winCount || 0})</th>
                  <th style={cellStyle}>Losses ({winLossSplit?.lossCount || 0})</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={cellStyle}>K/D</td>
                  <td style={cellStyle}>{winLossSplit?.wins?.kd || '--'}</td>
                  <td style={cellStyle}>{winLossSplit?.losses?.kd || '--'}</td>
                </tr>
                <tr>
                  <td style={cellStyle}>Score</td>
                  <td style={cellStyle}>{winLossSplit?.wins?.score || '--'}</td>
                  <td style={cellStyle}>{winLossSplit?.losses?.score || '--'}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h4 className="ppm-section-title">Map Performance</h4>
          <div style={{ border: '1px solid rgba(63,63,70,0.9)', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
            <table style={tableStyle}>
              <thead style={{ background: 'rgba(24,24,27,0.85)' }}>
                <tr>
                  <th style={cellStyle}>Map</th>
                  <th style={cellStyle}>Matches</th>
                  <th style={cellStyle}>Win %</th>
                </tr>
              </thead>
              <tbody>
                {(mapPerformance || []).length === 0 ? (
                  <tr><td style={cellStyle} colSpan={3}>No map data found.</td></tr>
                ) : (
                  (mapPerformance || []).map((row) => (
                    <tr key={`map-${row.map}`}>
                      <td style={cellStyle}>{row.map}</td>
                      <td style={cellStyle}>{row.matches}</td>
                      <td style={cellStyle}>{row.winPct}%</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <h4 className="ppm-section-title">Operator Analytics (HP + CTL)</h4>
          <div style={{ border: '1px solid rgba(63,63,70,0.9)', borderRadius: 10, overflow: 'hidden' }}>
            <table style={tableStyle}>
              <thead style={{ background: 'rgba(24,24,27,0.85)' }}>
                <tr>
                  <th style={cellStyle}>Operator</th>
                  <th style={cellStyle}>Uses</th>
                  <th style={cellStyle}>Avg Impact</th>
                </tr>
              </thead>
              <tbody>
                {(operatorAnalytics || []).length === 0 ? (
                  <tr><td style={cellStyle} colSpan={3}>No operator data found.</td></tr>
                ) : (
                  (operatorAnalytics || []).map((row) => (
                    <tr key={`op-${row.operator}`}>
                      <td style={cellStyle}>{row.operator}</td>
                      <td style={cellStyle}>{row.uses}</td>
                      <td style={cellStyle}>{row.avgImpact}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
};

export default FilteredStatsTab;
